export default __webpack_public_path__ + "static/media/black_time_icon.64bafab8.svg";